import React from 'react';
import InventoryCardPlaceHolder from '../InventoryCardPlaceHolder';
import FDPQPlaceHolder from '../FDPQPlaceHolder';
import FilteredPlaceHolder from '../FilteredPlaceHolder';

const TAB_SECTIONS_COUNT = 3;
const TAB_CONTENT_COUNT = 5;

function TabsPlaceHolder({ isMobile }) {
    return (
        <div className="tabPlaceHolder">
            <div className="tabSection">
                {Array(TAB_SECTIONS_COUNT)
                    .fill(null)
                    .map((_, index) => (
                        <div
                            key={`tab-skeleton-${index}`}
                            className="tab-section-loading skeleton__loading"
                        >
                            <div className="skeleton__headline skeleton__placeholder" />
                        </div>
                    ))}
            </div>
            <div className="tabContent">
                {isMobile ? (
                    <div className="margin-horizontal-5">
                        <FDPQPlaceHolder />
                        <FilteredPlaceHolder />
                        <InventoryCardPlaceHolder />
                    </div>
                ) : (
                    Array(TAB_CONTENT_COUNT)
                        .fill(null)
                        .map((_, index) => (
                            <div
                                key={`content-skeleton-${index}`}
                                className="tab-content-loading skeleton__loading"
                            >
                                <div className="skeleton__headline skeleton__placeholder" />
                            </div>
                        ))
                )}
            </div>
        </div>
    );
}

export default TabsPlaceHolder;
